import { createFeature, createReducer, on } from '@ngrx/store';
import type { AuthUser } from '../api/auth.api';
import { AuthActions } from './auth.actions';

export type AuthStatus = 'idle' | 'authenticating' | 'authenticated';

export interface AuthState {
  readonly user: AuthUser | null;
  readonly tenantId: string | null;
  readonly status: AuthStatus;
  readonly error: string | null;
  /** True once `Restore Session` has settled — route activation waits on this. */
  readonly restored: boolean;
}

export const initialAuthState: AuthState = {
  user: null,
  tenantId: null,
  status: 'idle',
  error: null,
  restored: false,
};

export const authFeature = createFeature({
  name: 'auth',
  reducer: createReducer(
    initialAuthState,

    on(AuthActions.login, (state) => ({
      ...state,
      status: 'authenticating' as const,
      error: null,
    })),

    on(AuthActions.loginSuccess, (state, { user, tenantId }) => ({
      ...state,
      user,
      tenantId,
      status: 'authenticated' as const,
      error: null,
    })),

    on(AuthActions.loginFailure, (state, { error }) => ({
      ...state,
      user: null,
      status: 'idle' as const,
      error,
    })),

    on(AuthActions.logoutSuccess, () => ({
      ...initialAuthState,
      restored: true,
    })),

    on(AuthActions.restoreSessionSuccess, (state, { user, tenantId }) => ({
      ...state,
      user,
      tenantId,
      status: user ? ('authenticated' as const) : ('idle' as const),
      restored: true,
    })),
  ),
});
